import { filter, orderBy } from "lodash-es";

import {
  type AssistantFollowUpObservable,
  type AssistantProjectObservable,
  type AssistantTaskObservable,
} from "@/store/assistant";
import { getAgentTimestamp } from "@/pages/agent/utils/agent-date.utils";
import { isClosedFollowUp } from "@/pages/agent/utils/agent-follow-up.utils";

export type TaskDetailViewModel = {
  task: AssistantTaskObservable;
  project: AssistantProjectObservable | null;
  projectTitle: string;
  nextFollowUp: AssistantFollowUpObservable | null;
  followUpCount: number;
};

export const buildTaskDetailViewModel = ({
  task,
  projects,
  followUps,
}: {
  task: AssistantTaskObservable;
  projects: AssistantProjectObservable[];
  followUps: AssistantFollowUpObservable[];
}): TaskDetailViewModel => {
  const project = task.projectId
    ? (projects.find(candidate => candidate.id === task.projectId) ?? null)
    : null;
  const taskFollowUps = filter(followUps, followUp => followUp.taskId === task.id);
  const openFollowUps = filter(taskFollowUps, followUp => !isClosedFollowUp({ followUp }));
  const nextFollowUp =
    orderBy(
      openFollowUps,
      followUp =>
        getAgentTimestamp({
          value: followUp.scheduledFor ?? followUp.dueAt,
          fallback: Number.POSITIVE_INFINITY,
        }),
      "asc"
    )[0] ?? null;

  return {
    task,
    project,
    projectTitle: project?.title ?? "No project",
    nextFollowUp,
    followUpCount: taskFollowUps.length,
  };
};
